
import { computed, getCurrentInstance, onMounted, ref, toRefs } from 'vue'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import Textarea from 'primevue/textarea'
import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import rgxExp from '@/utils/helpers/regExp'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import ButtonFileUpload from '@/views/components/button/FileUpload.vue'
import SelectFetch from '@/views/components/form/SelectAsync.vue'
import InputText from 'primevue/inputtext'
import { DatePicker } from 'v-calendar'
import moment from 'moment'
import Checkbox from 'primevue/checkbox'
import { isArray } from 'lodash'

export default {
  components: {
    Dialog,
    Button,
    Form,
    Field,
    // InputText,
    // DatePicker,
    // ButtonFileUpload,
    SelectFetch,
    Textarea,
    Checkbox
  },
  props: {
    show: {
      default: () => false
    },
    positionId: {
      default: () => null
    }
  },
  emits: ['hideForm', 'reloadParent'],
  setup(props: any, { emit } : any) {
    const moduleStore = 'hjpTable'
    const positionEndpoint = 'talent/v1/positions'
    const app = getCurrentInstance()
    const {
      $toast
    } = app!.appContext.config.globalProperties
    const { show, positionId, ritId } = toRefs(props)
    const store = useStore()
    const showModal = show.value
    const idPrams = ref(positionId.value.id)
    const title = ref('Tambah')
    const maxSizeFile = 1024 * 1024 * 1
    const tempImgProfile = ref<any | null>(null)

    const initialValues = {
      DocumentType: null,
      Notes: '',
      IsRequired: false
    }

    const schema = Yup.object().shape({
      DocumentType: Yup.object()
        .required('Jenis Dokumen tidak boleh kosong'),
    })

    const closeDialog = () => {
      console.log('close')
      emit('hideForm')
    }

    const onBack = () => {
      closeDialog()
    }

    const reloadParentAct = () => {
      emit('reloadParent')
    }

    const onInputFile = (file: any, typeUpload: string, setFieldValue: any) => {
      /* eslint-disable */
      if (file) {
        const totalSize: number = Number((file.size / 1024 / 1024).toFixed(1))
        if (totalSize > 1) {
          $toast.add({
            severity: 'error',
            detail: 'Ukuran file lebih dari 1MB.',
            group: 'bc',
            closable: false,
            life: 3000
          })
        } else {
          /* eslint-disable-next-line */
          if (file) {
            if (typeUpload === 'photo-profile') {
              // tempImgProfile.value = file.blob
              setFieldValue('ProfilePicture', { file: file.file, name: file.name, blob: file.blob })
            }
          }
        }
      }
    }

    const openDetailImg = (fileUrl: string) => {
      window.open(fileUrl, '_blank')
    }

    const processSubmit = async (payload: any) => {
      try {
        await apiUseCase.postOrPut(`${positionEndpoint}/${idPrams.value}/documentRequirements`, null, payload).then((response) => {
          const {
            error,
            result
          } = response
  
          if (!error) {
            $toast.add({
              severity: 'success',
              detail: 'Berhasil menyimpan Data',
              group: 'bc',
              closable: false,
              life: 3000
            })
            closeDialog()
            reloadParentAct()
          } else {
            $toast.add({
              severity: 'error',
              detail: 'Gagal menyimpan Data',
              group: 'bc',
              closable: false,
              life: 3000
            })
          }
        })
      } catch (error) {
        $toast.add({
          severity: 'error',
          detail: `Gagal menyimpan Data ${error}`,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
      store.dispatch('hideLoading')
    }

    const onSubmit = (values: any) => {
      store.dispatch('showLoading')
      console.log('values', values)
      const payload = {
        documentTypeId: values.DocumentType?.id,
        notes: values.Notes,
        isRequired: isArray(values.IsRequired) && values.IsRequired[0] === 'true' ? true : false
      }
      console.log('payload', payload)
      processSubmit(payload)
    }

    onMounted(() => {
      console.log('id', idPrams.value)
      if (idPrams.value) {
        title.value = 'Edit'
      }
    })

    return {
      showModal,
      closeDialog,
      schema,
      initialValues,
      title,
      onInputFile,
      maxSizeFile,
      openDetailImg,
      onSubmit,
      tempImgProfile,
      onBack
    }
  }
}

